import { Button, Modal, Result, Select } from "antd";
const { Option } = Select;

const SuccessResult = ({ show, title, subTitle, okText, onOkClick, onCancelClick = null, cancelText = null }) => {
    return (
        <Modal visible={show} centered closable={false} maskClosable={false} destroyOnClose={true} footer={null}>
            <Result
                status="success"
                title={title}
                subTitle={subTitle}
                extra={[
                    <Button key={`${subTitle}-OkButton`} type="primary" onClick={() => onOkClick && onOkClick()}>
                        {okText || "Ok"}
                    </Button>,
                    onCancelClick && (
                        <Button key={`${subTitle}-CancelButton`} onClick={() => onCancelClick && onCancelClick()}>
                            {cancelText || "Cancel"}
                        </Button>
                    ),
                ]}
            />
        </Modal>
    );
};

export default SuccessResult;
